import { TextField } from "@mui/material";
import { useController } from "react-hook-form";

export default function BTTextInput(props: any) {
	const { field, fieldState } = useController(props);
	const { onValChange } = props;

	return (
		<TextField
			label={props.label}
			name={field.name}
			value={field.value ? field.value : ""}
			inputRef={field.ref}
			onChange={(e) => {
				field.onChange(e);

				if (onValChange) onValChange(e);
			}}
			onBlur={field.onBlur}
			error={Boolean(fieldState.error)}
			helperText={fieldState.error?.message}
			size="small"
			type={props.type}
			disabled={props.disabled}
			inputProps={{
				autoComplete: "new-password",
				style: {
					textAlign: props.textAlign ? props.textAlign : "left",
					width: "100%",
				},
				form: {
					autoComplete: "off",
				},
			}}
		/>
	);
}
